function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "svg-mono",
  fill: "#050038",
  d: "M38.875 39.875l-6.25-1.375v-16c0-2.75-2-4.75-5-4.75s-5 2-5 4.75v17.375l-6.25-1.375v-16c0-2.75-2.125-4.75-5-4.75-3.125 0-5.125 2-5.125 4.75v17.375L0 38.5V13.375l6.25-1.25V15c1.75-2.125 4.5-3.375 7.5-3.375 2.125 0 4.75.75 6.875 2.75 2.125-2 4.5-2.75 7.5-2.75 4.375 0 10.75 3 10.75 11.125v17.125zM99.5 40c7.875 0 14.25-6.375 14.25-14.25 0-7.75-6.375-14.125-14.25-14.125-8 0-14.375 6.375-14.375 14.125C85.125 33.625 91.5 40 99.5 40zm0-5.875a8.375 8.375 0 0 1-8.375-8.375c0-4.5 3.75-8.25 8.375-8.25 4.5 0 8.25 3.75 8.25 8.25 0 4.625-3.75 8.375-8.25 8.375zm-22.75-22l3.625-.625V18l-3.625.625c-3.125.625-5.125 2.25-5.125 5.75V39.75l-6.25-1.25V23.375c0-7.5 4.5-9.75 11.375-11.25zm-27.375-11c-1.5 1.5-1.5 4 0 5.625 1.5 1.5 4.125 1.5 5.625 0 1.625-1.625 1.625-4.125 0-5.625-1.5-1.5-4.125-1.5-5.625 0zM49 38.5l6.25 1.5V11.875L49 13.25V38.5z"
});

var SvgMiro = function SvgMiro(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 40,
    viewBox: "0 0 114 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMiro, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/miro.55eff34c.svg";
export { ForwardRef as ReactComponent };